import './jspdf';



// WEBPACK FOOTER //
// ./src/plugins/index.js